import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'
import { toast } from 'react-toastify'
import { inject, observer } from 'mobx-react'

import { PAGEURL, APIURL } from '/constants'
import AdminLayout from '/components/layouts/AdminLayout'
import services from '/components/services'
import { ActionColumn, H1 } from '/components/theme/admin/common'
import { AdminButton } from '/components/theme/admin/AdminButton'

const tabs = (product_id, isSuperAdmin) => {
  const ts = [
    {
      name: 'Product Details',
      url: product_id
        ? PAGEURL.UPDATE_PRODUCT_DETAILS(product_id)
        : PAGEURL.NEW_PRODUCT,
      key: 'details'
    },
    {
      name: 'Product Description',
      url: PAGEURL.UPDATE_PRODUCT_DESCRIPTION(product_id),
      key: 'description'
    },
    {
      name: 'Product Actions',
      url: PAGEURL.UPDATE_PRODUCT_ACTIONS(product_id),
      key: 'action'
    },
    {
      name: 'Media',
      url: PAGEURL.PRODUCT_CAROUSEL_MEDIA(product_id),
      key: 'carouselmedia'
    },
    {
      name: 'FAQs',
      url: PAGEURL.FAQ_MGMT(product_id),
      key: 'faq'
    },
    {
      name: 'Reviews',
      url: PAGEURL.REVIEW_MGMT(product_id),
      key: 'review'
    },
    {
      name: 'Metadata',
      url: PAGEURL.PRODUCT_METADATA(product_id),
      key: 'metadata'
    }
  ]
  if (isSuperAdmin) {
    ts.push({
      name: 'Status',
      url: PAGEURL.PRODUCT_STATUS(product_id),
      key: 'status'
    })
  }
  return ts
}

const ProductAdminLayout = inject('store')(
  observer(({ store, children }) => {
    const [linked, setLinked] = useState(true)
    const handleTabClick = (e, url) => {
      e.preventDefault()
      router.push(url)
    }
    const router = useRouter()

    useEffect(() => {
      if (router.query.id !== 'add') {
        getLinked()
      }
    }, [router.query.id])

    async function getLinked() {
      try {
        const res = await services.post_v2(
          APIURL.API_ADMIN_CHECK_LINKED(router.query.id)
        )
        setLinked(res.response)
      } catch (e) {
        console.error(e)
      }
    }

    async function removeProduct() {
      if (confirm('Are you sure you want to delete this product?')) {
        try {
          const res = await services.delete_v2(
            APIURL.API_ADMIN_PRODUCT_DETAIL(router.query.id)
          )
          if (res.statusCode === 200) {
            toast('Product successfully deleted')
            router.push(PAGEURL.PRODUCT_MGNT)
          }
        } catch (e) {
          console.error(e)
        }
      }
    }

    function content() {
      const product_id = router.query.id
      const pathname = router.pathname
      return (
        <div className="content-right-panel">
          <H1>
            {product_id === 'add' ? 'Add' : 'Edit'} Product
            {product_id !== 'add' && (
              <ActionColumn collapse>
                {({ close }) => (
                  <>
                    <AdminButton
                      danger
                      onClick={async () => {
                        close()
                        await removeProduct()
                      }}
                    >
                      Remove Product
                    </AdminButton>
                  </>
                )}
              </ActionColumn>
            )}
          </H1>
          <ul className="admin-tab-list">
            {tabs(product_id, store.isSuperAdmin()).map((tab, index) => {
              if (!product_id && index > 0) return
              const url = tab.url
              if (product_id !== 'add' && !linked) {
                return (
                  <li
                    key={tab.key}
                    onClick={(e) => handleTabClick(e, url)}
                    className="pr-none cwp-review-tab-main admin-tabs"
                  >
                    <div
                      className={
                        'profile-category-title center-tabs ' +
                        (pathname.indexOf(tab.key) !== -1 ? 'active-tab' : '')
                      }
                    >
                      {tab.name}
                    </div>
                  </li>
                )
              }
            })}
          </ul>
          <div className="right-con-box">
            <div className="tableContent">{children}</div>
          </div>
        </div>
      )
    }

    return <AdminLayout>{content()}</AdminLayout>
  })
)

ProductAdminLayout.propTypes = {
  children: PropTypes.object
}

export default ProductAdminLayout
